import { Paper, Group, Text, Badge, UnstyledButton } from '@mantine/core';

export default function PipelineNode({ agent, selected, onClick }) {
  const promptCount = agent.prompt_keys?.length || 0;
  const toolCount = agent.tools?.length || 0;
  const qualityPct = ((agent.quality_threshold || 0.7) * 100).toFixed(0);

  return (
    <UnstyledButton onClick={onClick} style={{ width: '100%' }}>
      <Paper
        p="xs"
        radius="md"
        withBorder
        style={{
          borderColor: selected ? 'var(--mantine-color-blue-5)' : undefined,
          backgroundColor: selected ? 'var(--mantine-color-blue-0)' : undefined,
          cursor: 'pointer',
          transition: 'all 150ms ease',
        }}
      >
        <Group justify="space-between" wrap="nowrap" gap="xs">
          <Text size="sm" fw={selected ? 600 : 400} truncate>
            {agent.agent_name}
          </Text>
          <Group gap={4} wrap="nowrap">
            {agent.isCustomized && (
              <Badge size="xs" color="orange" variant="light">Custom</Badge>
            )}
            <Badge size="xs" variant="light" color="blue">{promptCount}P</Badge>
            <Badge size="xs" variant="light" color="teal">{toolCount}T</Badge>
            <Badge size="xs" variant="light" color="grape">{qualityPct}%</Badge>
          </Group>
        </Group>
      </Paper>
    </UnstyledButton>
  );
}
